<section class="app-card" [class.app-card--padded]="padded">
  <ng-content></ng-content>
</section>
